module.exports = __webpack_public_path__ + "static/01a-f47945a621a87f5895b1ef04341496f2.jpg";